export default __webpack_public_path__ + "static/logo-dark-63d39f1d6fbea44282652b452bae81e4.svg";